export default "__VITE_ASSET__B9A_icKe__"